import {connect} from 'react-redux';

import {WorkspaceDisplaySectionTrackingTypesEnum} from '../../../../../libs/shared/core/src/models/tracking/contexts/workspaceTracking';
import {
  InterfaceEventsEnum,
  trackInterfaceEvent,
} from '../../../../../libs/shared/core/src/services/tracking/tracking';
import {getShouldHideTeamTagCounters} from '../../../../../libs/shared/core/src/store/featureFlags/featureFlagsSelectors';
import {makeMapStateToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {defaultIsCustomViewExpanded} from '../../../../helpers/visualCustomViewHelpers';
import {VisualWorkspaceTag} from '../../../../models/api/visualWorkspaceModel';
import {AppState} from '../../../../store/appState';
import {getFindIsExpanded} from '../../../../store/data/localPreferences/localPreferencesSelectors';
import {nestSingleTagInsideNewParentAction} from '../../../../store/data/tags/saveTagActions';
import {WorkspaceDropReorderTagArgs} from '../../../../store/data/workspace/reorder/types';
import {makeGetVisualWorkspaceTeammateWorkspaceVisualCustomViews} from '../../../../store/data/workspace/visualWorkspace/visualWorkspaceSelectors';
import {reorderTagInPersonalWorkspaceAsyncAction} from '../../../../store/data/workspace/workspaceActions';
import {WorkspaceCustomViews} from '../workspaceCustomViews';

/*
 * Props.
 */

interface TeammateWorkspaceCustomViewsContainerProps {
  shouldAlphabetizeWorkspace: boolean;
  // Used for workspace v2 / visual workspace. Represents both private and team tags that appear in this workspace.
  visualWorkspaceTags: ReadonlyArray<VisualWorkspaceTag>;
}

/*
 * Selectors.
 */

function getVisualWorkspaceTags(_state: AppState, props: TeammateWorkspaceCustomViewsContainerProps) {
  return props.visualWorkspaceTags;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<TeammateWorkspaceCustomViewsContainerProps>()(() => ({
  visualCustomViews: makeGetVisualWorkspaceTeammateWorkspaceVisualCustomViews({
    getVisualWorkspaceTags,
    getOptionalAdditionalTagsMap: () => undefined,
    getOptionalParentTagOverridesMap: () => undefined,
    getFindIsItemExpanded: getFindIsExpanded,
    defaultExpandedState: defaultIsCustomViewExpanded,
    shouldRestrictToVisibleItems: true,
  }),
  shouldHideTeamTagCounters: getShouldHideTeamTagCounters,
}));

// These props don't depend on the component props, so don't use makeMapDispatchToProps.
const dispatchProps = {
  onDropReorderCustomView: (dropArgs: WorkspaceDropReorderTagArgs) => {
    trackInterfaceEvent(InterfaceEventsEnum.P1_WORKSPACE_REORDER, {
      section: WorkspaceDisplaySectionTrackingTypesEnum.TAGS,
    });
    return reorderTagInPersonalWorkspaceAsyncAction(dropArgs);
  },
  onDropNestCustomView: nestSingleTagInsideNewParentAction,
};

export const TeammateWorkspaceCustomViewsContainer = connect(
  mapStateToProps,
  dispatchProps,
)(WorkspaceCustomViews);
